import { createStore, type StoreConfig } from './state-helper'

type FraudStore = {
  sessionId?: string
  setFraud: (sessionId: string) => void
}

const createInitial = () => undefined

const getSetLocale: StoreConfig<FraudStore> = (set, get) => ({
  sessionId: createInitial(),
  setFraud: (sessionId: string) => {
    set({ sessionId })
  },
})

export const useFraudStore = createStore(getSetLocale, {
  name: 'fraud_storage',
})
